import { render, staticRenderFns } from "./matdetails.vue?vue&type=template&id=7a65b0c6&scoped=true&"
import script from "./matdetails.vue?vue&type=script&lang=js&"
export * from "./matdetails.vue?vue&type=script&lang=js&"
import style0 from "./matdetails.vue?vue&type=style&index=0&id=7a65b0c6&lang=scss&scoped=true&"
import style1 from "./matdetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65b0c6",
  null
  
)

export default component.exports